import React, { useState } from "react"
import { Typography, Box, TextField } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import { useAuth } from "../../services"

const useStyles = makeStyles((theme) => ({
  display: {
    "&&:hover": {
      backgroundColor: ({ canUpdate }) => (canUpdate ? theme.palette.inlineEditable.hover.background : null),
      cursor: "text",
    },
  },
}))

const InlineEditTextField = ({
  displayComponent = "span",
  displayVariant = "inherit",
  id,
  children,
  value,
  className,
  editable,
  editLabel,
  onEdited,
}) => {
  const { hasPermission } = useAuth()
  const canUpdate = editable && hasPermission(editable)
  const classes = useStyles({ canUpdate })

  const [editValue, setEditValue] = useState(false)
  const [newValue, setNewValue] = useState("")

  const handleEdit = () => {
    if (!canUpdate) return
    setNewValue(value)
    setEditValue(true)
  }

  const handleValueChange = (event) => {
    setNewValue(event.target.value)
  }

  const handleEdited = () => {
    onEdited && onEdited(newValue)
    setEditValue(false)
  }

  const handleEditKeyDown = (e) => {
    if (e.key === "Enter") {
      handleEdited()
    }
  }

  return (
    <>
      {!editValue && (
        <Typography
          id={id}
          component={displayComponent}
          variant={displayVariant}
          className={`${classes.display} ${className}`}
          onClick={handleEdit}
        >
          {children || value}
        </Typography>
      )}
      {editValue && (
        <Box mb={1}>
          <TextField
            id={id}
            label={editLabel}
            variant="outlined"
            value={newValue}
            onChange={handleValueChange}
            fullWidth
            required
            autoFocus
            onBlur={handleEdited}
            onKeyDown={handleEditKeyDown}
          />
        </Box>
      )}
    </>
  )
}

export { InlineEditTextField }
